<script setup lang="ts">
import { IconChevronRight } from "@tabler/icons-vue";
import {
	DropdownMenuSubTrigger,
	type DropdownMenuSubTriggerProps,
	useForwardProps,
} from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
	DropdownMenuSubTriggerProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<DropdownMenuSubTrigger
		v-bind="forwardedProps"
		:class="twMerge(
			'flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-hidden focus:bg-accent data-[state=open]:bg-accent',
			props.class,
		)"
	>
		<slot />
		<IconChevronRight class="ml-auto h-4 w-4" />
	</DropdownMenuSubTrigger>
</template>
